module.exports = __webpack_public_path__ + "img/accounts-color.0b4a667d.svg";